var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 456.86,
    height: 193.09,
    viewBox: "0 0 456.86 193.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -1514)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.516,
    cy: 72.516,
    r: 72.516,
    transform: "translate(621.829 1539)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.184,
    cy: 55.184,
    r: 55.184,
    transform: "translate(639.16 1556.331)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.791,
    cy: 47.791,
    r: 47.791,
    transform: "translate(646.553 1563.725)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.965 1589.45h31.832a9.836 9.836 0 019.836 9.835h0a9.837 9.837 0 01-9.836 9.836h-31.832m0 0h30.67a11 11 0 0111 11h0a11 11 0 01-11 11h-30.67m11.448-52.938v64.485m14.664-11.551v11.551m0-64.485v11.266",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.927 1557.17l3.01-17.068m6.282 19.558l5.928-16.286m2.789 20.351l8.666-15.009m-.786 20.526l11.14-13.276m-4.338 20.078l13.276-11.14m-7.758 19.02l15.009-8.666m-10.944 17.385l16.286-5.928m-13.797 15.219l17.068-3.01m-16.229 12.592h17.331m-18.17 9.583l17.068 3.01m-19.557 6.282l16.286 5.928m-20.351 2.79l15.009 8.666m-20.527-.787l13.276 11.14m-20.078-4.338l11.14 13.276m-19.02-7.758l8.666 15.009m-17.383-10.944l5.928 16.286m-15.22-13.797l3.01 17.068m-12.592-16.229v17.331m-9.583-18.17l-3.01 17.068m-6.282-19.557l-5.928 16.286m-2.789-20.351l-8.666 15.009m.785-20.527l-11.14 13.276m4.338-20.078l-13.276 11.14m7.759-19.019l-15.009 8.666m10.944-17.384l-16.286 5.928m13.797-15.22l-17.068 3.01m16.228-12.593h-17.331m18.171-9.582l-17.068-3.01m19.557-6.281l-16.286-5.928m20.351-2.791l-15.009-8.666m20.526.786l-13.276-11.14m20.078 4.338l-11.14-13.276m19.021 7.759l-8.666-15.009m17.383 10.944l-5.928-16.286m15.22 13.796l-3.01-17.068m12.593 16.23v-17.331m-141.734 36.257h22.032l18.947 18.947h13.149m.001 12.302h-58.725m58.724 14.592h-39.4l-19.3 19.3h-41.857",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.927,
    height: 16.945,
    rx: 5.463,
    transform: "translate(595.812 1564.263)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.927,
    height: 16.945,
    rx: 5.463,
    transform: "translate(522.66 1596.419)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.323 1564.904h6.525v16.3m-40.141 15.536h6.525v16.3m89.781 21.476h6.525v16.3",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.927,
    height: 16.945,
    rx: 5.463,
    transform: "translate(530.921 1652.558)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.927,
    height: 16.945,
    rx: 5.463,
    transform: "translate(579.675 1634.196)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.927,
    height: 16.945,
    rx: 5.463,
    transform: "translate(489 1652.558)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.965 1652.879h6.525v16.3",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.809 1577.741v-23.32a9.256 9.256 0 00-9.257-9.256h-55.9a9.257 9.257 0 00-9.257 9.256v111.832a9.257 9.257 0 009.257 9.257h55.9a9.256 9.256 0 009.257-9.257v-24.6m-74.41-82.229h74.411m-74.411 96.711h74.411",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.563,
    height: 6.187,
    rx: 3.094,
    transform: "translate(393.323 1661.728)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.078 1592.093c0 7.926-11.012 14.352-24.6 14.352s-24.6-6.425-24.6-14.35v35.209c0 7.927 11.012 14.353 24.6 14.353s24.6-6.426 24.6-14.353v-35.211z",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.596,
    cy: 14.352,
    rx: 24.596,
    ry: 14.352,
    transform: "translate(417.886 1577.74)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.078 1592.093c0 7.926-11.012 14.352-24.6 14.352s-24.6-6.426-24.6-14.352",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6e7e9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.078 1603.83c0 7.927-11.012 14.352-24.6 14.352s-24.6-6.425-24.6-14.352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.078 1615.567c0 7.927-11.012 14.352-24.6 14.352s-24.6-6.425-24.6-14.352"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.84 1528.921h65.763v16.249m-65.763 146.999h65.763v-16.655m-65.762-64.969h28.558",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4476.373 -2124.479)",
    stroke: "#6e7e9d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.92,
    cy: 13.92,
    r: 13.92,
    transform: "translate(4788.373 3639.479)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.92,
    cy: 13.92,
    r: 13.92,
    transform: "translate(4788.373 3721.104)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.92,
    cy: 13.92,
    r: 13.92,
    transform: "translate(4788.373 3802.728)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCoin);
export default __webpack_public_path__ + "static/media/phoneCoin.92e01e37dd82c67aba48415d6970cb9f.svg";
export { ForwardRef as ReactComponent };